export const loadingScreenMessages = {
  "loadingScreen.logoAlt": "CodeNomad logo",
  "loadingScreen.status.issue": "Encountered an issue",
  "loadingScreen.actions.showAnother": "Show another",
  "loadingScreen.errors.missingRoot": "Loading root element not found",

  "loadingScreen.phrases.neurons": "Warming up the AI neurons…",
  "loadingScreen.phrases.daydreaming": "Convincing the AI to stop daydreaming…",
  "loadingScreen.phrases.goggles": "Polishing the AI’s code goggles…",
  "loadingScreen.phrases.reorganizingFiles": "Asking the AI to stop reorganizing your files…",
  "loadingScreen.phrases.coffee": "Feeding the AI additional coffee…",
  "loadingScreen.phrases.nodeModules": "Teaching the AI not to delete node_modules (again)…",
  "loadingScreen.phrases.actNatural": "Telling the AI to act natural before you arrive…",
  "loadingScreen.phrases.rewritingHistory": "Asking the AI to please stop rewriting history…",
  "loadingScreen.phrases.stretch": "Letting the AI stretch before its coding sprint…",
  "loadingScreen.phrases.keyboardControl": "Persuading the AI to give you keyboard control…",
} as const
